import LoaderLoop from "./loader/LoaderLoop";
import "./GlobalLoader.css";

/**
 * ContentLoader — the CONTENT loader. In-flow, transparent, centered mint
 * loop with an optional Hebrew message. Use it wherever a page section,
 * card, list, table body, drawer or modal body is still loading.
 *
 *   {isLoading ? <ContentLoader message="טוען מטופלים..." /> : <List />}
 *   <ContentLoader size="sm" compact />            // small area / card
 *   <ContentLoader fill message="טוען יומן..." />   // stretch inside flex/grid parent
 *   <ContentLoader row size="xs" message="שומר..." />  // one line: loop + text
 *
 * For a blocking full-screen state use `GlobalLoader`.
 *
 * @param {string}  [message]
 * @param {"xs"|"sm"|"md"} [size="md"]
 * @param {boolean} [compact]  tight padding
 * @param {boolean} [fill]     stretch to fill the parent, min-height 160px
 * @param {boolean} [row]      horizontal layout
 * @param {string}  [className]
 */
function ContentLoader({ message, size = "md", compact = false, fill = false, row = false, className = "" }) {
  const cls = [
    "ck-loader",
    "ck-loader--content",
    compact && "ck-loader--compact",
    fill && "ck-loader--fill",
    row && "ck-loader--row",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={cls} role="status" aria-live="polite">
      <LoaderLoop size={row && size === "md" ? "sm" : size} />
      {message ? <p className="ck-loader-message">{message}</p> : <span className="ck-sr-only">טוען</span>}
    </div>
  );
}

export default ContentLoader;
